import "reflect-metadata";
import {inject, injectable} from "inversify";
import {PlanExtensionsCatalogRepository} from "@dropDesk/domain/repositories/plan_extensions/plan_extensions_catalog.repository";

@injectable()
export class UnsubscribePlanExtensionUseCase {
    private _repository: PlanExtensionsCatalogRepository;

    constructor(@inject(PlanExtensionsCatalogRepository) repository: PlanExtensionsCatalogRepository) {
        this._repository = repository;
    }

    public call(id: string): Promise<void> {
        return this._repository.unsubscribe(id);
    }
}
